import { useEffect, useRef } from "react";

/**
 * Soft radial glow that eases toward the cursor. Disabled on touch/coarse
 * pointers and under reduced motion. Returns a ref to attach to the glow div.
 */
const useCursorGlow = () => {
  const glowRef = useRef(null);

  useEffect(() => {
    const glow = glowRef.current;
    if (!glow || typeof window === "undefined" || !window.matchMedia) {
      return undefined;
    }

    const noHover = window.matchMedia("(hover: none)").matches;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (noHover || reduce) {
      return undefined;
    }

    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;
    let raf = 0;

    const loop = () => {
      currentX += (targetX - currentX) * 0.12;
      currentY += (targetY - currentY) * 0.12;
      glow.style.transform = `translate(${currentX}px, ${currentY}px)`;
      raf = window.requestAnimationFrame(loop);
    };

    const onMove = (event) => {
      targetX = event.clientX;
      targetY = event.clientY;
      glow.style.opacity = "1";
    };

    window.addEventListener("mousemove", onMove);
    loop();

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.cancelAnimationFrame(raf);
    };
  }, []);

  return glowRef;
};

export default useCursorGlow;
